import { OPERATIONS_BACKEND_URL } from '@/config'
import { runJsonPost } from '@/backend-client'

const COMMANDS_BASE_URL = OPERATIONS_BACKEND_URL + '/accounts/commands'

export async function savePreferedLanguage(changedLanguage) {
  await runJsonPost(`${COMMANDS_BASE_URL}/change-user-language`, {
    language: changedLanguage
  })
}
